<template>
    <AuthenticatedLayout>

        <Toast position="top-center" />

        <div class="text-4xl mt-4 mb-4 flex flex-row">
            <div>Preview HllBot for {{pair.symbol}}</div>
            <div class="ml-2">
                <a class="text-gray-400" :href="'https://ru.tradingview.com/chart/?symbol=BINANCE%3A'+pair.symbol" target="_blank"><i class="pi pi-external-link" style="font-size: 1.5rem"></i></a>
            </div>
        </div>

        <div class="mb-4">
            <Button class="p-button-success mr-3" label="Сохранить настройки" icon="pi pi-save" @click="saveSettings" />
<!--            <Button class="p-button-primary mr-3" label="Загрузить текущие рабочие настройки"  @click="loadSettings" />-->
            <Button class="p-button-primary mr-6" label="Загрузить настройки по умолчанию"  @click="loadDefaultSettings" />
            <Link :href="'/hll/'+pair.symbol" class="no-underline"><Button class="p-button-primary" label="Вернуться в рабочий бот" /></Link>
        </div>

        <div class="flex flex-row mb-4">

            <div class="w-32rem mr-4 flex flex-col">
                <Card class="">
                    <template #title>Bot</template>
                    <template #content>
                        <HllBotSettings v-model="form.botSettings" />
                    </template>
                </Card>
            </div>

            <div class="w-30rem mr-4 flex flex-column">
                <Card class="mb-4">
                    <template #title>HLL <span class="text-sm font-normal">hllIndicator</span></template>
                    <template #content>
                        <HllIndicatorSettings v-model="form.hllIndicatorSettings" />
                    </template>
                </Card>

                <Card class="mb-4">
                    <template #title>DontSellLong <span class="text-sm font-normal">dontSellLongIndicator</span></template>
                    <template #content>
                        <DontSellLongSettings v-model="form.dontselllongIndicatorSettings" />
                    </template>
                </Card>

                <Card class="mb-4">
                    <template #title>Middletrend <span class="text-sm font-normal">trendIndicator</span></template>
                    <template #content>
                        <MiddletrendSettings v-model="form.middletrendIndicatorSettings" />
                    </template>
                </Card>
            </div>


            <div class="w-30rem mr-4 flex flex-column">
                <Card class="mb-4">
                    <template #title>Slowtrend <span class="text-sm font-normal">TrendIndicator</span></template>
                    <template #content>
                        <TrendIndicatorSettings v-model="form.slowtrendIndicatorSettings" />
                    </template>
                </Card>

                <Card class="">
                    <template #title>Band <span class="text-sm font-normal">BandIndicator</span></template>
                    <template #content>
                        <BandIndicatorSettings v-model="form.bandIndicatorSettings" />
                    </template>
                </Card>
            </div>
        </div>

        <div class="flex flex-row mb-4">
            <Card class="w-full">
                <template #content>
                    <div class="flex flex-row align-items-end">
                        <div class="mr-4">
                            <div>Начало периода работы UTC</div>
<!--                            <Calendar v-model="form.dateStart" dateFormat="yy-mm-dd" :showTime="true" :showSeconds="false" />-->
                            <InputText type="text" v-model="form.dateStart" />
                        </div>
                        <div class="mr-4">
                            <div>Конец периода работы UTC</div>
<!--                            <Calendar v-model="form.dateEnd" dateFormat="yy-mm-dd" :showTime="true" :showSeconds="false" />-->
                            <InputText type="text" v-model="form.dateEnd" />
                        </div>
                        <div>
                            <SpinnerWrapper :loading="isLaunch">
                                <Button label="Протестировать период" @click="handleLaunch"></Button>
                            </SpinnerWrapper>
                        </div>
                    </div>
                </template>
                <template #footer v-if="errorLaunch">
                    <div class="text-red-500">{{errorLaunch}}</div>
                </template>
            </Card>
        </div>

        <div class="flex flex-row mb-4" v-if="showResults">

            <Card class="w-full">
                <template #content>
                    <div class="flex flex-row">
                        <div class="mr-8">
                            <div class="mb-2">
                                <span class="text-xl font-bold mr-2">Текущие результаты</span>
                                <span>({{durationSeconds}} сек.)</span>
                            </div>
                            <div class="flex flex-row">
                                <div class="text-lg mr-4">
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Закрытых сделок:</div>
                                        <div>{{closedDealsCount}}</div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Касаний maxOpenDeals:</div>
                                        <div>{{countReachMaxDeals}}</div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Профит:
                                            <span class="ml-1 text-gray-500 cursor-pointer">
                                                <i class="pi pi-question-circle"
                                                   v-tooltip.bottom="'Прибыль, которую покажет бот, запущенный с данными настройками'"></i></span>
                                        </div>
                                        <div v-html="round_colored(valueProfit, 2, '$')"></div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Движение рынка:</div>
                                        <div v-html="round_colored(deltaPricePercent, 0, '', '%')"></div>
                                    </div>
                                </div>
                                <div class="text-lg mr-4">
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Открытых сделок:</div>
                                        <div>{{openDealsCount}} <span class="text-base">(${{waitingSum}})</span></div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Профит:
                                            <span class="ml-1 text-gray-500 cursor-pointer">
                                                <i class="pi pi-question-circle"
                                                   v-tooltip.bottom="'Прибыль, если продать все открытые сделки в момент завершения периода работы'"></i></span>
                                        </div>
                                        <div class="text-base" v-html="round_colored(sellOpenDealsSum, 2, '$')"></div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Общий профит:
                                            <span class="ml-1 text-gray-500 cursor-pointer">
                                                <i class="pi pi-question-circle"
                                                   v-tooltip.bottom="'Итоговая прибыль, если мы хотим полностью выйти в USDT на момент завершения периода работы'"></i></span>
                                        </div>
                                        <div class="text-base" v-html="round_colored(valueProfit + sellOpenDealsSum, 2, '$')"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-4" v-if="prevResult">
                            <div class="mb-2">
                                <span class="text-xl mr-2">Прошлые результаты</span>
                                <span>({{prevResult.durationSeconds}} сек.)</span>
                            </div>
                            <div class="flex flex-row">
                                <div class="text-lg mr-4">
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Закрытых сделок:</div>
                                        <div>{{prevResult.closedDealsCount}}</div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Касаний maxOpenDeals:</div>
                                        <div>{{prevResult.countReachMaxDeals}}</div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Профит:</div>
                                        <div v-html="round_colored(prevResult.valueProfit, 2, '$')"></div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Движение рынка:</div>
                                        <div v-html="round_colored(prevResult.deltaPricePercent, 0, '', '%')"></div>
                                    </div>
                                </div>
                                <div class="text-lg mr-4">
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Открытых сделок:</div>
                                        <div>{{prevResult.openDealsCount}} <span class="text-base">(${{prevResult.waitingSum}})</span></div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Профит:
                                            <span class="ml-1 text-gray-500 cursor-pointer">
                                                <i class="pi pi-question-circle"
                                                   v-tooltip.bottom="'Прибыль, если продать все открытые сделки в момент завершения периода работы'"></i></span>
                                        </div>
                                        <div class="text-base" v-html="round_colored(prevResult.sellOpenDealsSum, 2, '$')"></div>
                                    </div>
                                    <div class="flex flex-row mb-2">
                                        <div class="w-14rem">Общий профит:
                                            <span class="ml-1 text-gray-500 cursor-pointer">
                                                <i class="pi pi-question-circle"
                                                   v-tooltip.bottom="'Итоговая прибыль, если мы хотим полностью выйти в USDT на момент завершения периода работы'"></i></span>
                                        </div>
                                        <div class="text-base" v-html="round_colored(prevResult.valueProfit + prevResult.sellOpenDealsSum, 2, '$')"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



<!--                    <div class="mb-4">-->
<!--                        <span v-if="showCandles === false" @click="showCandles = true" class="cursor-pointer underline">Раскрыть график</span>-->
<!--                        <span v-if="showCandles === true" @click="showCandles = false" class="cursor-pointer underline">Скрыть график</span>-->
<!--                    </div>-->

                    <div v-if="showCandles" class="mt-4">
                    <CandlesDealsHll
                        :candles="candles"
                        :deals="deals"
                        :indicators="indicators"
                        :pair="pair.symbol"
                        :width="maxWidth"
                        :height="500"
                        :timezone="0"
                        :zeroPrice="currentPrice"
                        :useBand="bot_settings.slowtrendUpBandBorder"
                    />
                    </div>

                    <div class="flex flex-row w-full mt-4">
                        <Card class="flex-1 mr-4">
                            <template #title>Сделки</template>
                            <template #content>
                                <ClosedDealsTable :deals="closedDeals" />
                            </template>
                        </Card>

                        <Card class="flex-1">
                            <template #title>Логи</template>
                            <template #content>
                                <LogsTable :logs="logs" :pagination="true"/>
                            </template>
                        </Card>
                    </div>

                </template>
            </Card>
        </div>

    </AuthenticatedLayout>
</template>
<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Toast from "primevue/toast";
import HllBotSettings from "@/Settings/HllBotSettings.vue";
import Card from "primevue/card";
import HllIndicatorSettings from "@/Settings/HllIndicatorSettings.vue";
import TrendIndicatorSettings from "@/Settings/TrendIndicatorSettings.vue";
import BandIndicatorSettings from "@/Settings/BandIndicatorSettings.vue";
import DontSellLongSettings from "@/Settings/DontSellLongSettings.vue";
import DontBuyLongSettings from "@/Settings/DontBuyLongSettings.vue";
import Calendar from "primevue/calendar";
import Button from "primevue/button";
import InputText from 'primevue/inputtext';
import SpinnerWrapper from "@/Components/SpinnerWrapper.vue";
import CandlesWithDealsAndIndicators from "@/Charts/CandlesDealsGrid.vue";
import CandlesWithDeals from "@/Charts/Candles.vue";
import helperMethods from "@/helpers";
import LogsTable from "@/Tables/LogsTable.vue";
import OpenDealsTable from "@/Tables/OpenDealsTable.vue";
import ClosedDealsTable from "@/Tables/ClosedDealsTable.vue";
import CandlesDealsHll from "@/Charts/CandlesDealsHll.vue";
import {Link} from "@inertiajs/vue2";
import MiddletrendSettings from "@/Settings/MiddletrendSettings.vue";

export default {
    props: {
        userBotId: Number,
        pair: Object,
        bot_settings: Object,
        hll_indicator_settings: Object,
        slowtrend_indicator_settings: Object,
        band_indicator_settings: Object,
        dontselllong_indicator_settings: Object,
        middletrend_indicator_settings: Object,
        dateStart: String,
        dateEnd: String,

        // candles: Array|null,
        // deals: Array|null,
        // indicators: Array|null,
        // currentPrice: Number|null,
        //
        // valueProfit: Number|null,
        // waitingSum: Number|null,
        // closedDealsCount: Number|null,
        // statsByCompleteReason: String|null,

    },
    components:{
        MiddletrendSettings,
        Link,
        CandlesDealsHll,
        ClosedDealsTable,
        OpenDealsTable,
        LogsTable,
        CandlesWithDeals,
        SpinnerWrapper,
        HllIndicatorSettings,
        BandIndicatorSettings,
        TrendIndicatorSettings,
        DontSellLongSettings, DontBuyLongSettings,
        HllBotSettings,
        AuthenticatedLayout,
        Toast, Card, Calendar, Button, InputText,
        CandlesWithDealsAndIndicators
    },
    data(){
        return {
            form:{
                botSettings: {},
                hllIndicatorSettings: {},
                slowtrendIndicatorSettings: {},
                bandIndicatorSettings: {},
                dontselllongIndicatorSettings: {},
                middletrendIndicatorSettings: {},
                dateStart: null,
                dateEnd: null,
            },

            isLaunch: false,
            showResults: false,
            showCandles: true,

            candles: null,
            deals: null,
            indicators: null,
            logs: null,
            currentPrice: null,

            valueProfit: null,
            waitingSum: null,
            closedDealsCount: null,
            openDealsCount: null,
            statsByCompleteReason: null,
            durationSeconds: null,
            deltaPricePercent: null,
            sellOpenDealsSum: null,
            countReachMaxDeals: null,

            prevResult: null,

            errorLaunch: null
        }
    },
    mounted() {
        this.form.botSettings = this.bot_settings;
        this.form.hllIndicatorSettings = this.hll_indicator_settings;
        this.form.slowtrendIndicatorSettings = this.slowtrend_indicator_settings;
        this.form.bandIndicatorSettings = this.band_indicator_settings;
        this.form.dontselllongIndicatorSettings = this.dontselllong_indicator_settings;
        this.form.middletrendIndicatorSettings = this.middletrend_indicator_settings;
        this.form.dateStart = this.dateStart;
        this.form.dateEnd = this.dateEnd;
    },
    computed:{
        closedDeals(){
            if(this.deals === null){
                return [];
            }
            return this.deals.filter(deal => deal.completed_at !== null);
        },
        maxWidth(){
            return window.innerWidth - 150;
        }
    },
    methods:{
        handleLaunch(){
            this.isLaunch = true;
            // this.candles = [];
            this.errorLaunch = null;
            let prevResultTemp = null;
            if(this.durationSeconds !== null){
                prevResultTemp = {
                    valueProfit: this.valueProfit,
                    waitingSum: this.waitingSum,
                    closedDealsCount: this.closedDealsCount,
                    openDealsCount: this.openDealsCount,
                    statsByCompleteReason: this.statsByCompleteReason,
                    durationSeconds: this.durationSeconds,
                    deltaPricePercent: this.deltaPricePercent,
                    sellOpenDealsSum: this.sellOpenDealsSum,
                    countReachMaxDeals: this.countReachMaxDeals,
                };
            }

            axios.post('/preview/hll/launch/', {
                pairId: this.pair.id,
                timeframe: this.form.botSettings.timeframe,
                form: this.form,
            }).then(response => {

                this.prevResult = prevResultTemp;

                this.candles = response.data.candles;
                this.deals = response.data.deals;
                this.indicators = response.data.indicators;
                this.logs = response.data.logs;
                this.currentPrice = response.data.currentPrice;

                this.valueProfit = response.data.valueProfit;
                this.waitingSum = response.data.waitingSum;
                this.closedDealsCount = response.data.closedDealsCount;
                this.openDealsCount = response.data.openDealsCount;
                this.statsByCompleteReason = response.data.statsByCompleteReason;
                this.durationSeconds = response.data.durationSeconds;
                this.deltaPricePercent = response.data.deltaPricePercent;
                this.sellOpenDealsSum = response.data.sellOpenDealsSum;
                this.countReachMaxDeals = response.data.countReachMaxDeals;

                this.isLaunch = false;
                this.showResults = true;

            }).catch(error => {
                this.isLaunch = false;
                // this.errorLaunch = error+" | ";
                if (error.response) {
                    this.errorLaunch = error.response.data.message;
                }

            });
        },
        saveSettings(){
            axios.post('/bot/store_hll_settings/', {
                id: this.userBotId,
                botSettings: this.form.botSettings,
                hllIndicatorSettings: this.form.hllIndicatorSettings,
                slowtrendIndicatorSettings: this.form.slowtrendIndicatorSettings,
                bandIndicatorSettings: this.form.bandIndicatorSettings,
                dontselllongIndicatorSettings: this.form.dontselllongIndicatorSettings,
                middletrendIndicatorSettings: this.form.middletrendIndicatorSettings
            }).then(response => {
                this.$toast.add({severity:'success', summary: 'Success', detail: 'Настройки записаны в работающего бота', life: 3000});
            })
        },
        loadSettings(){
            axios.post('/preview/load_settings/'+this.userBotId, {
            }).then(response => {
                this.form.botSettings = response.data.bot_settings;
                this.form.hllIndicatorSettings = response.data.hll_indicator_settings;
                this.form.slowtrendIndicatorSettings = response.data.trend_indicator_settings;
                this.form.bandIndicatorSettings = response.data.band_indicator_settings;
                this.form.dontselllongIndicatorSettings = response.data.dontselllong_indicator_settings;
                this.form.middletrendIndicatorSettings = response.data.middletrend_indicator_settings;
            })
        },
        loadDefaultSettings(){
            axios.post('/preview/load_default_settings/'+this.userBotId, {
            }).then(response => {
                this.form.botSettings = response.data.bot_settings;
                this.form.hllIndicatorSettings = response.data.hll_indicator_settings;
                this.form.slowtrendIndicatorSettings = response.data.trend_indicator_settings;
                this.form.bandIndicatorSettings = response.data.band_indicator_settings;
                this.form.dontselllongIndicatorSettings = response.data.dontselllong_indicator_settings;
                this.form.middletrendIndicatorSettings = response.data.middletrend_indicator_settings;
                this.$toast.add({severity:'success', summary: 'Success', detail: 'Загружены настройки по умолчанию', life: 3000});
            })


        },
        ...helperMethods
    }

}
</script>
